var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import ChannelContext from '@jetshop/core/components/ChannelContext';
import { formFieldsFromSettings } from '@jetshop/core/components/Auth/formFieldsFromSettings';
import throwErrorInDev from '@jetshop/core/helpers/throwErrorInDev';
import { useCountrySettings } from '../ChannelContext/useCountrySettings';
// Holds fields and other API data
export const SignupContext = React.createContext(undefined);
const SignupProvider = function SignupContextProvider(_a) {
    var { LoadingComponent } = _a, props = __rest(_a, ["LoadingComponent"]);
    // We will use the selectedChannel to build the form to begin with.
    // However, if the user changes country in the form, we should also change all
    // of the fields and validation
    const { selectedChannel } = React.useContext(ChannelContext);
    const [isUserTypeBusiness, setIsUserTypeBusiness] = React.useState(false);
    throwErrorInDev(!selectedChannel, 'Must be wrapped in ChannelContext Provider');
    // Initialise country to the selected channel country. This will be selected
    // by default in the form, and its settings will be used to build the form
    // inputs and validation
    const [country, setCountry] = React.useState(selectedChannel.country);
    const { countrySettings, loading } = useCountrySettings();
    const selectedCountrySettings = countrySettings &&
        countrySettings.find(c => c.countryCode === country.code);
    // Get all the billing address fields from the country settings
    const { allFields, billingAddressFields, loginFields } = !loading
        ? formFieldsFromSettings(selectedCountrySettings, isUserTypeBusiness)
        : {
            allFields: null,
            billingAddressFields: null,
            loginFields: null
        };
    const value = React.useMemo(() => {
        return {
            billingAddressFields,
            loginFields,
            allFields,
            selectedCountry: country,
            countries: selectedChannel.countries,
            setCountry,
            loading,
            isUserTypeBusiness,
            setIsUserTypeBusiness
        };
    }, [
        billingAddressFields,
        loginFields,
        allFields,
        country,
        selectedChannel.countries,
        loading,
        isUserTypeBusiness
    ]);
    if (loading) {
        return LoadingComponent || null;
    }
    else
        return React.createElement(SignupContext.Provider, Object.assign({ value: value }, props));
};
// Holds formik state
export const SignupFormikContext = React.createContext(undefined);
export default SignupProvider;
//# sourceMappingURL=signup-context.js.map